export default "__VITE_ASSET__xUSnV4PX__"